export const getProductLabelFormByQuantity = (quantity: number) => {
    switch (true) {
        case quantity === 1:
            return 'produkt'
        case quantity > 1 && quantity < 5:
            return 'produkty'
        default:
            return 'produktów'
    }
}